export const IDS = 'creativeIds';
export const CHANNELS = 'channels';
export const LANGUAGE = 'languageId';
export const ENHANCERS = 'enhancerIds';
export const TAGS = 'tagIds';
export const POSTFIX = 'postfix';
export const OUTSOURCE_STUDIO_ID = 'outsourceStudioId';
export const DESIGNER = 'authorId';
export const NETWORKS = 'networkIds';
export const EXCLUSIVE_FOR_AFFILIATES = 'exclusiveForAffiliateIds';
export const REQUESTED_BY = 'requestedById';
export const JIRA_TASK = 'jiraTask';
export const TESTED = 'tested';
export const DESCRIPTION = 'description';
export const AI_GENERATED = 'isAICreated';
export const PRODUCTION_TYPE = 'productionTypeId';
